import React from "react";
// libs
import axios from "src/libs/axios";
// const
import { ENDPOINTS } from "src/constants/endpoints";
// types
import { TClinicDetails } from "src/types";

interface IUseClinicsResponse {
  loadClinics: (params?: string) => Promise<TClinicDetails[]>;
  loadClinic: (id: number | string) => Promise<TClinicDetails>;
  loadNearestClinicDetails: (
    lng: number | string,
    lat: number | string,
    params?: string,
  ) => Promise<any>;
}

type TUseClinics = () => IUseClinicsResponse;

export const useClinics: TUseClinics = () => {
  const loadClinics: IUseClinicsResponse["loadClinics"] = async (params = "") => {
    const { data } = await axios.get(ENDPOINTS.GET.clinics + "?" + params);
    return data;
  };

  const loadClinic: IUseClinicsResponse["loadClinic"] = async (id) => {
    const { data } = await axios.get(ENDPOINTS.GET.clinic(id));
    return data;
  };

  const loadNearestClinicDetails: IUseClinicsResponse["loadNearestClinicDetails"] = async (
    lng,
    lat,
    params = "",
  ) => {
    const { data } = await axios.get(
      ENDPOINTS.GET.nearestClinicDetails + `?lng=${lng}&lat=${lat}&${params}`,
    );
    return data;
  };

  return {
    loadClinics,
    loadClinic,
    loadNearestClinicDetails,
  };
};
